import { render, staticRenderFns } from "./ednSkeletonTemplate.vue?vue&type=template&id=0efdfe9b&"
import script from "./ednSkeletonTemplate.vue?vue&type=script&lang=js&"
export * from "./ednSkeletonTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ednSkeletonTemplate.vue?vue&type=style&index=0&id=0efdfe9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports